import Metadata from "../metadata.js";
import { VALID_DIGITS } from "../constants.js";
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadata) {
  if (country) {
    var countryMetadata = new Metadata(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) === 0) {
      number = number.slice(number.match(IDDPrefixPattern)[0].length);
      var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
      if (!(matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0 && matchedGroups[1] === "0"))
        return number;
    }
  }
}
export {
  stripIddPrefix as default
};
//# sourceMappingURL=stripIddPrefix.js.map
